import { render } from "./iconUsers.vue?vue&type=template&id=6c7f45ec"
import script from "./iconUsers.vue?vue&type=script&lang=js"
export * from "./iconUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__